import { ReactNode } from 'react';

type MarkAsPaidFieldRowProps = {
  label: string;
  required?: boolean;
  children: ReactNode;
};

const MarkAsPaidFieldRow = ({
  label,
  required = false,
  children
}: MarkAsPaidFieldRowProps) => (
  <div className="flex flex-col gap-6">
    <div className="flex items-center justify-between">
      <h3 className="text-sm font-medium text-grey">
        {label}
        {required && (
          <>
            {' '}
            <span className="text-error">*</span>
          </>
        )}
      </h3>
      {children}
    </div>
  </div>
);

export default MarkAsPaidFieldRow;
